var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(!this.url)?_c('div',[(
        (this.loader || this.objetoRetorno.aguarde) &&
        !this.objetoRetorno.mensagem
      )?_c('Loading'):_vm._e()],1):_vm._e(),(this.url)?_c('div',{staticClass:"embed-responsive embed-responsive-1by1",staticStyle:{"height":"100%","min-height":"700px"}},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"src":this.url}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }